module.exports = __webpack_public_path__ + "static/media/specialrate.78215dd8.svg";